import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import { Card, Col, Container, Form, Image, ListGroup, Row } from 'react-bootstrap'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
// FormLabel
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Link, useParams, useNavigate } from 'react-router-dom'
// import DatePicker from 'react-mobile-datepicker'
// import DatePicker from 'react-datepicker'
import { faciltyOnMarker, getFaciltyData, postCardPaymentDetails, fetchRateBands, fetchRateDetailData, postWarningCardPaymentDetails } from '../../redux/actions/transientAction'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import 'react-toastify/dist/ReactToastify.css'
import {
    encryptionHandler,
    getFormattedTime,
    getCardIcon, getFieldValue, getHoursForRateBand, isPermissionExist, isPromoValidateButton, loggedInUserData,
    priceGreaterOrNot,
    sortPortalPermissionByKey,
    TimeConversion,
    getConvertedDate,
    convertTimeToDoubleDig
} from '../../utils/helper'
import URL from '../../constants/urls'
import './Trans.scss'
import Loader from '../../global/Loader'
import Footer from '../../components/global/Footer'
import NoData from '../../components/NoData'
// import MiniHeader from '../../components/global/MiniHeader'
import { errorMessage } from '../../constants/errorMessage'
import { getTicketDetails } from '../../redux/actions/userDetails'
import PaymentGateDc from './PaymentGatwayDc'
// import axios from 'axios'
import UpperHeader from '../../components/global/UpperHeader'
import AmountPaid from '../../components/global/AmountPaid'
import DownloadApp from '../../components/global/DownloadApp'
import PromoCode from '../../components/global/PromoCode'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import { getVehilceData, getVehicleModelList } from '../../redux/actions/VehicleAction'
import VehicleHod from '../vehicle/VehicleHod'
import { getCardLists } from '../../redux/actions/PaymentAction'
import PaymentModal from '../../components/global/Payment/PaymentModal'
// import { Circles } from 'react-loader-spinner'
import { checkActiveSession } from '../../redux/actions/ReceiptsAction'
import ConfirmationTerms from '../../global/ConfirmationTerms'
import CommonListModal from '../../global/CommonListModal'
// rate band
import RateBandDropDownList from '../../global/RateBandDropDownModal'
// 
// import carImage from '../../assets/img/vehicle.png'
// import card_top_image from '../../assets/img/card_top.png'
import ReactMobiltySpinner from '../../global/ReactMobiltySpinner'
import moment from 'moment-timezone'
import ParkingSchModal from '../../global/ParkingSchModal'
import { Circles } from 'react-loader-spinner'
import ScrollCalendar from '../scrollCalendar/ScrollCalendar'
import StartEndDateTime from '../scrollCalendar/StartEndDateTime'
// import ActiveSession from '../../components/global/ActiveSession'
// import { getConfigDetails } from '../../services/config'
import ReservationWithID from '../../components/global/ReservationWithID'
import RateDetailsModal from '../../components/global/RateBand/RateDetailsModal'
import { getFacilityRateDetails, getWarningDetails } from '../../../../redux/actions/WarnCitationAction'
import WarningModal from '../../WarningModal'
// import NotFound from '../../../bookingPortal/not-found/error-404'
import { TimeConversionInHours } from '../../../../utils/helper'
import { getConfigDetails } from '../../../../services/config'

function TransientForm(props) {
    const { register, handleSubmit, formState: { errors }, control, setValue, reset, getValues, setFocus } = useForm()
    const [faciltyData, setFaciltyData] = useState(EMPTY_OBJECT)
    const [timeDuration, setTimeDuration] = useState({ days: '0', hours: '0', minutes: '0' })
    const [totalHoursLength, setTotalHoursLength] = useState('0.00')
    const [stateList, setStateList] = useState(EMPTY_ARRAY)
    const [checkInData, setCheckInData] = useState(EMPTY_OBJECT)
    const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
    const [errorMessageLocal, setErrorMessageLocal] = useState('')
    const [isTokenApiStarts, setIsTokenApiStart] = useState(false)
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [isDisplayDetails, setIsDisplayDetails] = useState(false)
    const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false)
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
    const [isCheckingActiveSession, setIsCheckingActiveSession] = useState(true)
    const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
    const [formData, setFormData] = useState(EMPTY_OBJECT)
    const [cardData, setCardData] = useState(EMPTY_ARRAY)
    const [vehicleData, setVehicleData] = useState(EMPTY_ARRAY)
    const [isCommonModalOpen, setCommonModal] = useState(false)
    const [currentSelVehicle, setCurrentVehicle] = useState(EMPTY_OBJECT)
    const [currentSelCard, setCurrentCard] = useState(EMPTY_OBJECT)
    const [selOptionFlag, setSelOptionFlag] = useState('')
    // 
    const [warningMessageSchdule, setWarningPark] = useState(false)
    const [avalablityAlert, setAvalablityAlertIsOpen] = useState(false)
    const [availabilityMessage, setAvalablityMessage] = useState('')
    const [warningMessage, setWarningMessage] = useState('')
    const [hoursOfOper, setHoursOfOper] = useState(EMPTY_ARRAY)
    const [midnighNote, setShowMidnightNote] = useState(false)
    const [isSubmittingForm, setIsSubmittingForm] = useState(false)
    const [onSubmitData, setOnSubmitData] = useState(EMPTY_OBJECT)
    // const [currentRateBand, setCurrentRateBand] = useState(EMPTY_OBJECT)

    // rate Band 
    const [isDisplayRateBand, setIsDisplayRateBand] = useState(false)
    const [isRateBandModalOpen, setIsRateBandModalOpen] = useState(false)
    const [rateBandData, setRateBandData] = useState(EMPTY_ARRAY)
    const [rateBands, setRateBands] = useState(EMPTY_ARRAY)
    const [seletedRateBand, setSeletedRateBand] = useState('')
    const [isValidPartner, setIsValidPartner] = useState(true)
    const [partnerdetails, setPartnerDetails] = useState(EMPTY_OBJECT)
    const [isScrollCalendarModal, setIsScrollCalendarModal] = useState(false)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
    const [vehicleModel, setvehicleModel] = useState(EMPTY_ARRAY)
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
    const [othermake ,  SetOtherMake ] = useState(false)
    const [othermodel,  SetOtherModel ] = useState(false)
    // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
    // const [activeSessionData, setActiveSessionData] = useState(EMPTY_OBJECT)
    const [displayBanner, setDisplayBanner] = useState(false)
    const [selctedDateTime, setselctedDateTime] = useState({
        active: false,
        price: null,
        daysHrs: null,
        dateUntill: null,
        bandActive: false,
    })
    const [rateDetailModal, setRateDetailModal] = useState({
        modal: false,
        details: null
    })
    const [reservationData, setReservationData] = useState({
        reservationID: null,
        license_plate: null
    })
    const [isResetModalOpen, setResetModalOpen] = useState(false)
    const [rateObj, setRateObj] = useState({
        loader: false,
        data: null
    })
    const [noPage, setNoPage] = useState(false)
    const toggle = () => setResetModalOpen(!isResetModalOpen)
    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))

    const zoneList = [{ val: 'A', name: 'A' }, { val: 'B', name: 'B' }, { val: 'C', name: 'C' }]


    const timeRoundOff = (date) => {
        const start = moment(new Date(date))
        const remainder = 5 - (start.minute() % 5)
        return moment(start).add(remainder, 'minutes').format('MM-DD-YYYY hh:mm A')
    }
    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')
    
    const d2 = new Date(getConvertedDate(moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')))
    const [entryDateTime, setEntryDateTime] = useState(d2)
    const [isRateBandSelected, setIsRateBandSelected] = useState(true)
    //const [exitDateTime,setExitDateTime] = useState(new Date())

    
    const [stEndCalendar, SetstEndCalendar] = useState({
        start: false,
        end: false,
        start_date: null,
        end_date: null,
        defaultEndDate: null
    })

    const [warnCitData, SetwarnCitData] = useState({
        warning: null,
        citation: null,
        showLicense: false,
        recall: 0,
        timeZone: null
    })
    const [modaltog, setModaltog] = useState(true)




    // params 
    let { facility, partner, route, id } = useParams()
    const { dispatch, loader, notify, vehicleDataList, cards, isFetchingPartner, partnerDetails } = props
    const { ref } = register('phone')
    const navigate = useNavigate()

    useEffect(() => {
        // console.log(entryDateTime, 'entryDateTime1')
        setFocus('phone')
    }, [setFocus])

    useEffect(() => {
        localStorage.removeItem('seletedRateBand')
        localStorage.removeItem('faclityData')
        localStorage.removeItem('partnerData')
			sessionStorage.removeItem('partnerData')
    }, [])



    useEffect(() => {
        window.scrollTo(0, 0)
        localStorage.setItem('history', JSON.stringify({ route: route, facility: facility }))
        const loginData = loggedInUserData()
        const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost.facility.id : null
        setLoginData(loginData)

        // get partner by slug
        if (partner) {
            // dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
            if (partnerDetails?.email) {
                dispatch(getVehicleModelList()).then((res) => {
                    getVehicle(res)
                })
                // console.log(partnerDetails, 'response')
                setPartnerDetails(partnerDetails)
                setIsValidPartner(true)

                const hasAccess = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Download Banner')
                setDisplayBanner(hasAccess)

                localStorage.removeItem('partnerData')
                sessionStorage.removeItem('partnerData')
                localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
                const partnerData = partnerDetails

                const color = partnerData?.brand_setting?.color
                const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                if (color) {
                    document.documentElement.style.setProperty('--bs-primary', color)
                    document.documentElement.style.setProperty('base-color', color)
                    document.documentElement.style.setProperty('primary', color)
                    document.documentElement.style.setProperty('textcolor', color)
                    document.documentElement.style.setProperty('--bs-btn-bg', color)
                    document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                    document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-bg', color)

                    if (facility && facility != undefined && facility != 'undefined') {
                        const finalPayload = { 'encrypt': facility }
                        handlePostApiForUpdatedList(finalPayload, false)
                    }else{
                        notify('error', 'Sorry something went wrong, Please refresh or try again.')
                    }

                    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')
                    const d2 = new Date(getConvertedDate(moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')))
                    let dateTime = timeRoundOff(d2)
                    let dateTimeStart = new Date(dateTime)
                    setValue('entry_time', dateTimeStart)
                    setEntryDateTime(d2)
                }

            } else {
                if (partnerDetails) {
                    setIsValidPartner(true)
                } else {
                    setIsValidPartner(false)
                }
                localStorage.removeItem('partnerData')
                sessionStorage.removeItem('partnerData')
            }
            // }).catch(() => {

            // })
        }





        // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
        // if (loggedInUserData()?.access_token) {
        //     getUserActiveCheckins()
        // }

        if (loginData?.access_token) {

            dispatch(getVehilceData()).then((res) => {
                setVehicleData(res?.data)
                const filterobj = res?.data?.filter((item) => item?.is_default == '1')
                reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : res?.data?.[0]?.id }))
                setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : res?.data?.[0])
            }).catch((err) => {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            })
            if (localFacilityID) {
                dispatch(getCardLists(localFacilityID)).then((res) => {
                    setCardData(res?.data?.payments)
                    reset(formValues => ({ ...formValues, 'card_id': res?.data?.payments?.[0]?.card_holder_id }))
                    setCurrentCard(res?.data?.payments?.[0])
                }).catch((err) => {
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        }
        
    }, [EMPTY_ARRAY, partnerDetails])


    useEffect(() => {
        const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost.facility.id : null
        // console.log(entryDateTime, 'entryDateTime2')
        if (loginData?.access_token) {
            if ((cards?.length != cardData?.length) && localFacilityID) {
                dispatch(getCardLists(localFacilityID)).then((res) => {
                    setCardData(res?.data?.payments)
                    reset(formValues => ({ ...formValues, 'card_id': res?.data?.payments?.[0]?.card_holder_id }))
                    setCurrentCard(res?.data?.payments?.[0])
                }).catch((err) => {
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
            if (vehicleDataList?.length != vehicleData?.length) {
                dispatch(getVehilceData()).then((res) => {
                    setVehicleData(res?.data)
                    const filterobj = res?.data?.filter((item) => item?.is_default == '1')
                    reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : res?.data?.[0]?.id }))
                    setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : res?.data?.[0])
                }).catch((err) => {
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        }
    }, [EMPTY_ARRAY, cards, vehicleDataList])

    useEffect(() => {
        if (reservationData?.license_plate) {
            reset(formValues => ({ ...formValues, 'license_plate': reservationData.license_plate, state: '' }))
            // console.log(getValues(), 'getValues')
        }
    }, [reservationData])

    const getVehicle = (res) => {
        let makeList = res?.make
        makeList?.unshift({
            'id': 'Others',
            'name': 'Others',
            'mst_model': [{
                'id': 'Others',
                'make_id': 'Others',
                'name': 'Others'
            }]
        })
        setVehicleMakeList(makeList)
        setVehicleDetailsList(res)

    }

    const handlePostApiForUpdatedList = (finalPayload, fetchByRate, fromDatePicker = false) => {
        // console.log(selctedDateTime, 'fromDatePicker')
        // if(fromDatePicker) {
        //     setselctedDateTime({...selctedDateTime, bandActive: true})
        // }
        let checkoutWithTime = false
        if(finalPayload.checkoutWithTime) {
            checkoutWithTime = true
            delete finalPayload.checkoutWithTime
        }
        setIsTokenApiStart(true)
        // console.log(finalPayload, 'finalPayload')
        dispatch(getFaciltyData(finalPayload)).then((res) => {
            setIsTokenApiStart(false)
            if (res?.data) {
                // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.parking_amount ? res?.data?.parking_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_rate ? res?.data?.tax_rate : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee ? res?.data?.processing_fee : '0.00'}` }]
                if (fromDatePicker) {
                    setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                }
                // console.log(selctedDateTime, 'selctedDateTime', res.data)
                const data = res?.data
                data.default_length = data?.default_length?.toString()
                localStorage.setItem('faclityData', JSON.stringify(data))


                const dcap = {
                    DATACAP_OTU_URL: data?.DATACAP_OTU_URL,
                    DATACAP_SCRIPT_URL: data?.DATACAP_SCRIPT_URL,
                    DATACAP_TOKEN: data?.DATACAP_TOKEN,
                }
                localStorage.setItem('dcap', JSON.stringify(dcap))
                setStateList(res?.data?.states)

                let lpr = JSON.parse(localStorage.getItem('lpr'))
                // SetstEndCalendar({ ...stEndCalendar, end_date: res?.data?.checkout_time ? getDateFormatToshow(res?.data?.checkout_time) : null})
                SetstEndCalendar({ ...stEndCalendar, start_date: res?.data?.checkin_time_warning ? res?.data?.checkin_time_warning : (lpr?.entry_time) ? lpr.entry_time : null, end_date: res?.data?.checkout_time ? res?.data?.checkout_time : res?.data?.current_time ? res?.data?.current_time : null })
                // rate band start 
                if (fetchByRate) {
                    const rateDataFectched = { ...faciltyData, ...res?.data }
                    setFaciltyData(rateDataFectched)
                } else {
                    setFaciltyData(res?.data)
                }

                // rate band end 
                const geoState = res?.data?.facility?.geolocations?.state?.trim()
                const filteredState = res?.data?.states?.filter((item) => (item?.state_code === geoState || item?.name === geoState) ? item : 0)

                setValue('state', getValues('state') ? getValues('state') : filteredState[0]?.id ? filteredState[0]?.id : getValues('state'))
                let APIFacilityTimeZone = data?.facility?.timezone
                if (data?.facility?.is_price_band == '1') {
                    // SET RATE BAND TRUE
                    setIsDisplayRateBand(true)
                    // FETCH RATE BANDS API DETAILS
                    const payload = {
                        facility_id: res?.data?.facility?.id,
                        user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    }
                    let lprData = JSON.parse(localStorage.getItem('lpr'))
                    let lprExit = JSON.parse(localStorage.getItem('lprExit'))
                    dispatch(fetchRateBands(payload)).then((res) => {
                        if (res?.data) {
                            // SET RATE BANDS DATA
                            // console.log(res.data, 'res.data')
                            if(lprData?.entry_time) {
                                let lprDate = new Date(getConvertedDate(moment(new Date(lprData?.entry_time)).format('YYYY-MM-DD HH:mm:ss')))
                                let curTime = lprExit?.entry_time ? new Date(getConvertedDate(moment(lprExit?.entry_time).format('YYYY-MM-DD HH:mm:ss'))) : new Date(getConvertedDate(moment(new Date()).tz(APIFacilityTimeZone ? APIFacilityTimeZone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                                let hoursDiff = moment(curTime).diff(lprDate, 'minutes')
                                let data = res?.data?.price_band.filter((item) => {
                                    let hourToMin = Number(item.max_stay) * 60
                                    return hourToMin > hoursDiff
                                })
                                // console.log(data, 'I am here... 1')
                                setRateBandData(data)
                                const rateBandsForSelection = data?.map((item) => item?.rate_band_description)
                                const priceForRateBrands = data?.map((item) => item?.price)
                                const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                setRateBands(rateBands)
                            } else {
                                setRateBandData(res?.data?.price_band)
                                const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                                const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                                // const defaultRateBand = [
                                //     'Select Rate Band'
                                // ]
                                const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                // console.log(rateBands, res?.data?.price_band, 'I am here... 2')
                                setRateBands(rateBands)
                            }
                            
                        } else {
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }).catch((err) => {
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                }

                if (loggedInUserData()?.access_token) {
                    const payload = {
                        facility_id: res?.data?.facility?.id,
                        user_id: loggedInUserData()?.user?.id
                    }
                    setIsCheckingActiveSession(true)
                    dispatch(checkActiveSession(payload)).then((res) => {
                        if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
                            let paymentData = res?.data?.checkin_details
                            if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
                                localStorage.setItem('isCouponApplied', true)
                            }

                            delete res?.data?.checkin_details
                            const facility = res?.data
                            const finalPaymentData = { ...paymentData, facility: facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                            setIsCheckingActiveSession(false)
                        } else {
                            setIsTokenApiStart(false)
                            setIsCheckingActiveSession(false)
                        }
                    }).catch(() => {
                        setIsTokenApiStart(false)
                        setIsCheckingActiveSession(false)
                        // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    setIsCheckingActiveSession(false)
                    setIsTokenApiStart(false)
                }
            } else {
                setIsTokenApiStart(false)
                setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                if (res?.errors?.message == 'Garage is currently closed.') {
                    setAvalablityAlertIsOpen(true)
                    setAvalablityMessage(res?.errors?.message)
                } else if(res?.errors?.message == 'The Facility is not operational at this moment.') {
                    setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsCheckingActiveSession(false)
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            }
            if(checkoutWithTime) {
                const currentTime = res?.data?.checkin_time_warning ? moment(res?.data?.checkin_time_warning, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : moment(res?.data?.current_time).format('YYYY-MM-DD HH:mm:ss')
                const checkoutTime = moment(res?.data?.checkout_time).format('YYYY-MM-DD HH:mm:ss')
                const totalHours = moment(checkoutTime).diff(currentTime, 'minutes')
                const timeRemain = TimeConversionInHours(totalHours)
                // console.log(currentTime, checkoutTime, totalHours, timeRemain, 'time diff here')
                setTotalHoursLength(timeRemain)
            }
        }).catch((err) => {
            setIsTokenApiStart(false)
            setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (err?.errors?.message == 'Garage is currently closed.') {
                setAvalablityAlertIsOpen(true)
                setAvalablityMessage(err?.errors?.message)
            } else if(err?.errors?.message == 'The Facility is not operational at this moment.') {
                setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsCheckingActiveSession(false)
            } else {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            }
        })
    }
    const deb = useCallback(
        debounce((payload, fetchByRate, fromDatePicker) => {
            handlePostApiForUpdatedList(payload, fetchByRate, fromDatePicker)
        }, 300),
        [])

    const handleTimeLength = (e) => {
        // e?.preventDefault()
        const { value, name } = e.target
        let data = { ...timeDuration }
        if (name == 'day') {
            data['days'] = value
            setTimeDuration({ ...timeDuration, days: Number(value) })
        } else if (name == 'hour') {
            data['hours'] = value
            setTimeDuration({ ...timeDuration, hours: Number(value) })
        } else if (name == 'minute') {
            data['minutes'] = value
            setTimeDuration({ ...timeDuration, minutes: Number(value) })
        } else if (name == 'minute-up') {
            data['minutes'] = data.minutes + 15 <= 60 ? Number(data.minutes + 15) : 0
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes + 15 <= 60 ? Number(prev.minutes + 15) : 0 }))
        } else if (name == 'minute-down') {
            data['minutes'] = data.minutes - 15 >= 0 ? Number(data.minutes - 15) : 60
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes - 15 >= 0 ? Number(prev.minutes - 15) : 60 }))
        } else if (name == 'hour-up') {
            data['hours'] = data.hours + 1 <= 24 ? Number(data.hours + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours + 1 <= 24 ? Number(prev.hours + 1) : 0 }))
        } else if (name == 'hour-down') {
            data['hours'] = data.hours - 1 >= 0 ? Number(data.hours - 1) : 24
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours - 1 >= 0 ? prev.hours - 1 : 24 }))
        } else if (name == 'day-up') {
            data['days'] = data.days + 1 <= 31 ? Number(data.days + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days + 1 <= 31 ? Number(prev.days + 1) : 0 }))
        } else if (name == 'day-down') {
            data['days'] = data.days - 1 >= 0 ? Number(data.days - 1) : 31
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days - 1 >= 0 ? Number(prev.days - 1) : 31 }))
        }


        if (name === 'Hours') {
            data['hours'] = Number(value)
            setTimeDuration(data)
            let totalHours = TimeConversion(data).toFixed(2)
            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            } else {
                setTotalHoursLength(totalHours)
            }
            // const payload = { 'encrypt': facility, length: totalHours === 0 ? 2 : totalHours }
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = { 'encrypt': facility, length: totalHours }
                if (payload?.length !== 0) {
                    deb(payload, false)
                }
            }else{
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
            }
        } else {
            let totalHours = TimeConversion(data).toFixed(2)
            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            } else {
                setTotalHoursLength(totalHours)
            }
            // const payload = { 'encrypt': facility, length: totalHours === 0 ? 2 : totalHours }
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = { 'encrypt': facility, length: totalHours }
                if (payload?.length !== 0) {
                    deb(payload, false)
                }
            }else{
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
            }
        }

        // only for rate band 

        if ((name && name?.[0]) === 'rateBands') {
            const { value } = e.target
            const seletedRateBand = rateBandData?.filter((item) => item?.rate_band_description == value[0])
            // for the rate hour 
            const rateBandHour = getHoursForRateBand(seletedRateBand)
            localStorage.setItem('seletedRateBand', JSON.stringify(seletedRateBand?.[0]))
            setSeletedRateBand(seletedRateBand)
            // to set hours duration
            data['hours'] = Number(rateBandHour)

            let totalHours = '0.00'

            if (seletedRateBand?.[0]?.max_stay) {
                const max_stay_time = seletedRateBand?.[0]?.max_stay?.split('.')
                const minutes = (Number(max_stay_time[1]) / 60)
                totalHours = Number(max_stay_time[0]) + Number(minutes)
            }

            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            }
            // else {
            //     setTotalHoursLength(totalHours)
            // }

            setTimeDuration(data)

            reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
            // FETCH FACILITYRATE
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = {
                    promocode: '',
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    rate_band_id: seletedRateBand?.[0]?.id,
                    //facility_id: faciltyData?.facility?.id,
                    // length_of_stay: totalHoursLength,
                    'encrypt': facility,
                    checkoutWithTime: true
                }
                if(id) {
                    // console.log(stEndCalendar, 'stEndCalendar')
                    payload.is_warning = 1
                    if(warnCitData?.warning?.lprDetails) {
                        payload.entry_time = warnCitData.warning.lprDetails?.entry_time
                    }
                    if(warnCitData.warning.lprExitDetails) {
                        payload.exit_time = warnCitData.warning.lprExitDetails?.entry_time
                    }
                }
                if (payload?.length != 0) {
                    deb(payload, false)
                }
            }else{
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
            }
        }
    }


    const handleChange = (e) => {
        const { value, name } = e.target
        const updatedCheckinData = { ...checkInData }
        if (name == 'make') {
            let modelData = vehicleDetailsList?.make?.filter((v) => v.id == value)
            let modelList = (Object.values(modelData).length != 0 ? modelData?.[0]?.mst_model : [])
			modelList.unshift({
				'id': 'Others',
				'make_id': 'Others',
				'name': 'Others'
		})
            setvehicleModel(modelData[0]?.mst_model)
            setvehicleModelList(modelList)
            SetOtherMake(value == 'Others' ? true : false)
            updatedCheckinData[name] = value
            setCheckInData(updatedCheckinData)
            setValue(name, value)
            console.log(vehicleModel)
            // vehicleData[name] = value
            // setVehicleData([...vehicleData])
        } else if(name == 'model'){
             SetOtherModel(value == 'Others' ? true : false)
             updatedCheckinData[name] = value
            setCheckInData(updatedCheckinData)
            setValue(name, value)
        } else {
            updatedCheckinData[name] = value
            setCheckInData(updatedCheckinData)
            setValue(name, value)
        }

    }

    const handleActiveCheckInCheck = () => {
        if ((checkInData?.license_plate && checkInData?.phone) || (ticketDetails?.ticket_number && checkInData?.phone) || (checkInData?.license_plate && ticketDetails?.ticket_number)) {
            const payload = {
                'ticket': '',
                'phone': checkInData?.phone,
                'cardLast4': '',
                'cardExpiry': '',
                'license_plate': checkInData?.license_plate
            }
            dispatch(getTicketDetails(payload)).then((res) => {
                if (res?.status === 201 || res?.status === 200) {
                    if (res?.data && res?.data != null && res?.data?.is_expired == '0') {
                        localStorage.removeItem('paymentRecipt')
                        localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
                        setTicketDetails(res?.data)
                    } else {
                        setTicketDetails('')
                        localStorage.setItem('paymentRecipt', '{}')
                        // notify('error', 'No record found')
                    }
                } else {
                    setTicketDetails('')
                    localStorage.setItem('paymentRecipt', '{}')
                    // setError(res?.errors?.message)
                    // notify('error', res?.errors?.message)
                }
            }).catch(() => {
                setTicketDetails('')
                localStorage.setItem('paymentRecipt', '{}')
                // notify('error', 'Something went wrong!')
            })
        }
    }

    // new code function  

    const onSubmit = (data) => {
        setIsSubmittingForm(true)
        localStorage.removeItem('phone')
        if (reservationData.reservationID === null) {
            if (!isSubmittingForm) {
                setOnSubmitData(data)
                // setIsTokenApiStart(true)
                const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                const currArrivalTime = moment.utc(new Date()).subtract(210, 'm').format('DD-MM-YYYY HH:mm:ss')
                const markerPayload = {
                    facility_id: facilityLocData?.facility?.id,
                    arrival_time: currArrivalTime,
                    length_of_stay: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                    rate_band_id: seletedRateBand?.[0]?.id,
                    user_id: loginData?.user?.id ? loginData?.user?.id : 0
                }
                const minHours = facilityLocData?.minmum_length ? parseFloat(facilityLocData?.minmum_length) : 0
                if ((totalHoursLength == '0' || totalHoursLength == '0:00' || totalHoursLength == '0.00')) {
                    setIsSubmittingForm(false)
                    // if (isDisplayRateBand) {
                    //     notify('error', 'Please select valid duration')
                    // } else {
                    notify('error', 'Please select a valid duration')
                    // }
                    setIsTokenApiStart(false)
                } else if (facilityLocData?.minmum_length && (minHours > parseFloat(markerPayload.length_of_stay))) {
                    let timeToShow = getFormattedTime(facilityLocData?.minmum_length)
                    setIsSubmittingForm(false)
                    notify('error', 'Please select minimum duration ' + timeToShow + ' hours')
                    setIsTokenApiStart(false)
                } else {
                    dispatch(faciltyOnMarker(markerPayload)).then((res) => {
                        // setIsSubmittingForm(false)
                        if (Number(res?.data?.warning_on_reservation) === 1 && res?.data?.facility_hours_of_operation?.length > 0) {
                            setWarningPark(!warningMessageSchdule)
                            setWarningMessage(res?.data?.warning_on_reservation_msg)
                            setHoursOfOper(res?.data?.facility_hours_of_operation)
                            const selData = res?.data?.facility_hours_of_operation?.filter((item) => item?.formatted_close_time == '12:00 am (midnight next day)')
                            setShowMidnightNote(selData.length > 0 ? true : false)
                            setIsSubmittingForm(false)
                        } else if ((Number(res?.data?.availability) === 0 && res?.data?.availability_msg !== '' && res?.data?.price === 'N/A')) {
                            setAvalablityAlertIsOpen(!avalablityAlert)
                            setAvalablityMessage(res?.data?.availability_msg)
                            setIsSubmittingForm(false)
                        } else if (res?.Error) {
                            setIsSubmittingForm(false)
                            notify('error', res?.data ? res?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
                        } else {
                            handleSubmitAction(data)
                            setIsSubmittingForm(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
                    })
                }
            }
        } else {
            if (loginData?.access_token) {
                const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                let finalPayload = {}
                if (data?.vehicle_id && data?.vehicle_id != '') {
                    finalPayload = {
                        facility_id: faciltyData?.facility?.id,
                        phone: loginData?.user?.phone_number,
                        // email: loginData?.user?.email ? loginData?.user?.email : '',
                        vehicle_id: data?.vehicle_id, reservation_id: reservationData.reservationID,
                        discount_amount: facilityLocData?.discount_amount,
                        promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                        total: faciltyData?.payable_amount,
                        user_id: loggedInUserData()?.user?.id,
                        check_warning: 0,
                        length: Number(totalHoursLength).toFixed(2),
                    }
                    if(id) {
                        finalPayload.is_warning = 1
                        finalPayload.warning_id = id
                        if(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) {
                            finalPayload.start_date = stEndCalendar?.start_date
                            finalPayload.end_date = stEndCalendar?.end_date
                        } else {
                            finalPayload.start_date = faciltyData?.current_time
                            finalPayload.end_date = faciltyData?.checkout_time
                        }
                        dispatch(postWarningCardPaymentDetails(finalPayload)).then((res) => {
                            if (res?.status === 201 && res?.data) {

                                const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                                localStorage.removeItem('paymentRecipt')
                                localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                // setIsSubmittingForm(false)
                                navigate(`/${partner}${URL?.CONFIRMATION}`)
                                setIsTokenApiStart(false)
                            } else {
                                if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                    setIsConfimationModalOpen(true)
                                    setIsSubmittingForm(false)
                                } else {
                                    setIsSubmittingForm(false)
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                }
                                setIsTokenApiStart(false)
                            }
                        }).catch((err) => {
                            setIsSubmittingForm(false)
                            if (err?.errors?.message && err?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                            } else {
                                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        })
                    } else {
                        dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                            if (res?.status === 201 && res?.data) {
    
                                const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                                localStorage.removeItem('paymentRecipt')
                                localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                // setIsSubmittingForm(false)
                                navigate(`/${partner}${URL?.CONFIRMATION}`)
                                setIsTokenApiStart(false)
                            } else {
                                if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                    setIsConfimationModalOpen(true)
                                    setIsSubmittingForm(false)
                                } else {
                                    setIsSubmittingForm(false)
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                }
                                setIsTokenApiStart(false)
                            }
                        }).catch((err) => {
                            setIsSubmittingForm(false)
                            if (err?.errors?.message && err?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                            } else {
                                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        })
                    }
                } else {
                    setIsSubmittingForm(false)
                    notify('error', 'Please add a Vehicle and Card')
                }
            } else {
                const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                let finalPayload = {}
                finalPayload = {
                    facility_id: faciltyData?.facility?.id,
                    license_plate: data?.license_plate,
                    color: data?.color,
                    make: data?.make == 'Others' ? data?.maketext : data?.make,
                    model: data?.model == 'Others' ? data?.modeltext : data?.model,
                    phone: data?.phone,
                    state_id: data?.state,
                    length: Number(totalHoursLength).toFixed(2),
                    discount_amount: facilityLocData?.discount_amount,
                    promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                    total: faciltyData?.payable_amount,
                    check_warning: 0,
                    reservation_id: reservationData.reservationID
                }
                if (faciltyData?.facility?.is_price_band == 1) {
                    finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                }
                if(id) {
                    finalPayload.is_warning = 1
                    finalPayload.warning_id = id
                    if(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) {
                        finalPayload.start_date = stEndCalendar?.start_date
                        finalPayload.end_date = stEndCalendar?.end_date
                    } else {
                        finalPayload.start_date = faciltyData?.current_time
                        finalPayload.end_date = faciltyData?.checkout_time
                    }
                    dispatch(postWarningCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
                            if (data?.phone) {
                                localStorage.setItem('phone', data?.phone)
                            }
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            // setIsSubmittingForm(false)
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                                setIsSubmittingForm(false)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        setIsTokenApiStart(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
                            if (data?.phone) {
                                localStorage.setItem('phone', data?.phone)
                            }
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            // setIsSubmittingForm(false)
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                                setIsSubmittingForm(false)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        setIsTokenApiStart(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                }
            }
        }
    }

    const handleSubmitAction = (formData) => {
        // console.log(formData, 'formData')
        let data

        if (formData && Object.values(formData).length > 0) {
            data = formData
        } else {
            data = { ...onSubmitData }
        }

        setWarningPark(false)
        setAvalablityAlertIsOpen(false)
        // if (loginData?.access_token || faciltyData?.payable_amount=='0') {
        if (loginData?.access_token) {
            finalPaymentToBackend('', data)
        } else {
            // const payload = {
            //     'Account': data?.card_number ? data?.card_number : '',
            //     'ExpirationMonth': data?.expiry ? data?.expiry.substr(0, 2) : '',
            //     'ExpirationYear': data?.expiry ? `20${data?.expiry.substr(2, 5)}` : '',
            //     'CVV': data?.cvv ? data?.cvv : ''
            // }
            // const headers = { 'Authorization': faciltyData?.DATACAP_TOKEN, 'Content-Type': 'application/json', Accept: 'application/json' }
            // axios.post(faciltyData?.DATACAP_OTU_URL, payload, { headers })
            // .then((response) => {
            //     if (response?.data) {
            //         finalPaymentToBackend(response?.data, data)
            //     } else if (response?.Error) {
            //         setIsSubmittingForm(false)
            //         setIsTokenApiStart(false)
            //         notify('error', response?.data ? response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setIsSubmittingForm(false)
            //     setIsTokenApiStart(false)
            //     notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            // })
            const card = {
                name_on_card: data?.name_on_card,
                card_number: data?.card_number,
                expiration_date: data?.expiry,
                security_code: data?.cvv,
                zip_code: ''
            }
            const nonce = encryptionHandler(card)
            finalPaymentToBackend(nonce, data)
        }
    }

    const finalPaymentToBackend = (data, upperData) => {

        if (loginData?.access_token) {

            setFormData(upperData)
            handleLoggedInUserCheckIn(0, upperData)
        } else {

            const updatedData = { ...upperData, ...{ nonce: data } }
            setFormData(updatedData)
            handleGuestUserCheckIn(0, updatedData)
        }
    }

    const handleLoggedInUserCheckIn = (warning, upperData) => {
        if (!isSubmittingForm) {
            const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
            let finalPayload = {}
            if (upperData?.vehicle_id && upperData?.vehicle_id != '' && upperData?.card_id && upperData?.card_id != '') {
                finalPayload = {
                    facility_id: faciltyData?.facility?.id,
                    phone: loginData?.user?.phone_number,
                    // email: loginData?.user?.email ? loginData?.user?.email : '',
                    vehicle_id: upperData?.vehicle_id,
                    length: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                    discount_amount: facilityLocData?.discount_amount,
                    promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                    total: faciltyData?.payable_amount,
                    payment_profile_id: upperData?.card_id,
                    user_id: loggedInUserData()?.user?.id,
                    check_warning: warning
                }
                if (faciltyData?.facility?.is_price_band == 1) {
                    finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                }
                if(id) {
                    finalPayload.is_warning = 1
                    finalPayload.warning_id = id
                    if(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) {
                        finalPayload.start_date = stEndCalendar?.start_date
                        finalPayload.end_date = stEndCalendar?.end_date
                    } else {
                        finalPayload.start_date = faciltyData?.current_time
                        finalPayload.end_date = faciltyData?.checkout_time
                    }
                    dispatch(postWarningCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
    
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                            setIsTokenApiStart(false)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                                setIsSubmittingForm(false)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        if (err?.errors?.message && err?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                            setIsConfimationModalOpen(true)
                        } else {
                            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        setIsTokenApiStart(false)
                    })
                } else {
                    dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
    
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                            setIsTokenApiStart(false)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                                setIsSubmittingForm(false)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        if (err?.errors?.message && err?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                            setIsConfimationModalOpen(true)
                        } else {
                            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        setIsTokenApiStart(false)
                    })
                }
            } else {
                notify('error', 'Please add a Vehicle and Card')
            }
        }
    }
    const handleGuestUserCheckIn = (warning, upperData) => {
        if (!isSubmittingForm) {
            if (upperData?.nonce && upperData?.nonce != '' && upperData?.nonce != null && upperData?.nonce != undefined) {

                const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                let finalPayload = {}
                finalPayload = {
                    facility_id: faciltyData?.facility?.id,
                    license_plate: upperData?.license_plate,
                    color: upperData?.color,
                    make: upperData?.make == 'Others' ? upperData?.maketext : upperData?.make,
                    model: upperData?.model == 'Others' ?  upperData?.modeltext :  upperData?.model,
                    phone: upperData?.phone,
                    // email: upperData?.email,
                    state_id: upperData?.state,
                    length: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                    discount_amount: facilityLocData?.discount_amount,
                    promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                    total: faciltyData?.payable_amount,
                    check_warning: warning,
                    nonce: upperData?.nonce,
                }
                if (faciltyData?.facility?.is_price_band == 1) {
                    finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                }
                if(id) {
                    finalPayload.is_warning = 1
                    finalPayload.warning_id = id
                    if(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) {
                        finalPayload.start_date = stEndCalendar?.start_date
                        finalPayload.end_date = stEndCalendar?.end_date
                    } else {
                        finalPayload.start_date = faciltyData?.current_time
                        finalPayload.end_date = faciltyData?.checkout_time
                    }
                    dispatch(postWarningCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
    
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
    
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        setIsTokenApiStart(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                        if (res?.status === 201 && res?.data) {
    
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
    
                            navigate(`/${partner}${URL?.CONFIRMATION}`)
                        } else {
                            if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                                setIsConfimationModalOpen(true)
                            } else {
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                        }
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        setIsTokenApiStart(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                }
            } else {
                notify('error', errorMessage?.somethingWentWrong)
            }
        }
    }

    const handleAddVehilce = () => { setIsVehicleModalOpen(!isVehicleModalOpen) }

    const handlePaymentModal = () => { setIsPaymentModalOpen(!isPaymentModalOpen) }

    const handleCommonListModal = (key) => {
        if (key == 'Card') {
            if (cardData?.length > 0) {
                setCommonModal(!isCommonModalOpen)
                setSelOptionFlag(key)
            } else {
                handlePaymentModal()
            }
        } else {
            if (vehicleData?.length > 0) {
                setCommonModal(!isCommonModalOpen)
                setSelOptionFlag(key)
            } else {
                handleAddVehilce()
            }
        }
    }

    const handleCurrentSelection = (item) => {
        if (selOptionFlag == 'Vehicle') {
            reset(formValues => ({ ...formValues, 'vehicle_id': item?.id }))
            setCurrentVehicle(item)
        } else if (selOptionFlag == 'RateBand') {
            reset(formValues => ({ ...formValues, 'rate_band_id': item?.id }))
            // setCurrentRateBand(item)
            // FETCH FACILITYRATE
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = {
                    promocode: '',
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    rate_band_id: item?.id,
                    //facility_id: faciltyData?.facility?.id,
                    length_of_stay: '',
                    'encrypt': facility,
                }
                if (payload?.length != 0) {
                    deb(payload, true)
                }
            }else{
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
            }

        } else {
            reset(formValues => ({ ...formValues, 'card_id': item?.card_holder_id }))
            setCurrentCard(item)
        }

    }

    // const handleRateBand = (e) => {
    //     const { name, value } = e.target
    //     const seletedRateBand = rateBandData?.filter((item) => item?.rate_band_description == value[0])
    //     // reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
    //     // FETCH FACILITYRATE
    //     console.log('name', name)
    //     if (name?.[0] === 'rateBands') {
    //         const payload = {
    //             promocode: '',
    //             user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
    //             rate_band_id: seletedRateBand?.[0]?.id,
    //             //facility_id: faciltyData?.facility?.id,
    //             length_of_stay: '',
    //             'encrypt': facility,
    //         }
    //         console.log('payload', payload)
    //         // if (payload?.length !== 0) {
    //         // deb(payload, true)
    //         // }
    //     }
    //     console.log('e', e)
    // }



    // rate band

    // const handleRateBandModal = () => {
    //     setSelOptionFlag('RateBand')
    //     // if (rateBandData?.length == 0) {
    //         setIsRateBandModalOpen(true)
    //     // } else {
    //     //     setIsRateBandModalOpen(false)
    //     // }
    // }

    // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
    // const getUserActiveCheckins = () => {
    //     const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
    //     const payload = {
    //         facility_id: '',
    //         user_id: loggedInUserData()?.user?.id
    //     }
    //     dispatch(checkActiveSession(payload)).then((res) => {
    //         if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
    //             let paymentData = res?.data?.checkin_details
    //             if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
    //                 localStorage.setItem('isCouponApplied', true)
    //             }
    //             localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
    //             if(res?.data?.id == savedFacility?.facility?.id){
    //                 navigate(`/${partner}${URL?.CONFIRMATION}`)
    //             }
    //             setActiveSessionData(res?.data)
    //             setIsCheckingActiveSession(false)
    //         } else {
    //             setIsTokenApiStart(false)
    //             setIsCheckingActiveSession(false)
    //         }
    //     }).catch(() => {
    //         setIsTokenApiStart(false)
    //         setIsCheckingActiveSession(false)
    //     })
    // }

    const handleEntryTime = (event) => {
        setIsRateBandSelected(false)
        localStorage.removeItem('seletedRateBand')
        // setEntryDateTime(event)
        setValue('entry_time', event)
        // console.log(event)
        // let currentTime = exitDateTime
        const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
        // const currentTime = moment(new Date().toLocaleString('en-US', { timeZone: savedFacility?.facility?.timezone })).format('MM-DD-YYYY hh:mm A')
        // const currentTime = moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')
        const currentTime = new Date(getConvertedDate(moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        // const eventTime = new Date(getConvertedDate(moment(event).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        // console.log(currentTime, getCurrentTime, 'getCurrentTime')

        // console.log(event, currentTime, 'Event')
        let hours = diff_hours(event, currentTime)
        // notify('success', hours)
        if (facility && facility != undefined && facility != 'undefined') {
            const payload = { 'encrypt': facility, length: hours, rate_band_id: '' }
            if (payload?.length != 0) {
                deb(payload, false, true)
            }
        }else{
            notify('error', 'Sorry something went wrong, Please refresh or try again.')
        }
    }

    const diff_hours = (endTime, startTime) => {
        // let start = moment(new Date(getConvertedDate(new Date(startTime)))).format('MM/DD/YYYY HH:mm:ss') //moment(startTime)?.format('MM/DD/YYYY HH:mm:ss')
        // let end = moment(new Date(getConvertedDate(new Date(endTime)))).format('MM/DD/YYYY HH:mm:ss') //moment(endTime)?.format('MM/DD/YYYY HH:mm:ss')
        
        // let start= getConvertedDate(moment(startTime)?.format('MM/DD/YYYY HH:mm:ss'))
        let start = new Date(getConvertedDate(moment(startTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        let end = new Date(getConvertedDate(moment(endTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        var diff = moment(end).diff(start, 'minutes')
        // var d = Math.floor(diff / (3600*24))
        // var h = Math.floor(diff % (3600*24) / 3600)
        // var m = Math.floor(diff % 3600 / 60)
        // const startDate = new Date(start)
        // const endDate = new Date(end)
        // console.log(diff, 'timeDiff')
        let timeDiff
        if (!isNaN(start) && !isNaN(end)) {
            // const timeDifferenceInMilliseconds = endDate - start
            var hours = Math.floor(diff / 60)
            var minutes = Math.floor(diff % 60)
            // return hours + " hours and " + minutes + " minutes";

            // const timeDifferenceInMilliseconds = endDate - startDate
            // const hours = Math.floor(timeDifferenceInMilliseconds / 3600000)
            // const minutes = Math.floor(
            //     (timeDifferenceInMilliseconds % 3600000) / 60000
            // )
            // console.log(hours, minutes)
            timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
            // timeDiff = ((d*24) + h) + '.' + (m<10 ? '0'+(m+1) : (m+1))
        } else {
            timeDiff = 'Invalid Time'
        }

        setTotalHoursLength(timeDiff)
        return timeDiff
    }
    const getHoursIndate = (hours) => {
        if (Number(hours) > 0) {
            const day = Math.floor(Number(hours) / 24)
            if (Number(hours) % 24 === 0) {
                return `${day} ${day === 1 ? 'Day' : 'Days'}`
            }
            console.log((Number(hours) < 1) ? hours + ' MM' : (Number(hours) === 1) ? hours + ' HR' : hours + ' HRS', 'Test')

            return (Number(hours) < 1) ? convertTimeToDoubleDig(hours) + ' MM' : (Number(hours) === 1) ? convertTimeToDoubleDig(hours) + ' HR' : convertTimeToDoubleDig(hours) + ' HRS'
        }
    }

    const getDateFormatToshow = (dt) => {
        return moment(dt).format('MMM DD, YYYY hh:mm A')
    }

    const openDateCalendar = () => {
        setIsScrollCalendarModal(true)
        // console.log('atest')
    }

    const handlePermitPurchase = () => {
        if (loggedInUserData()?.access_token && loggedInUserData()?.refresh_token) {
            window.open(`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalBASEURL : getConfigDetails()?.portalBASEURL}/navigating/${loggedInUserData()?.access_token}/${loggedInUserData()?.refresh_token}/0/${facility}/${partner}`, '_self')
        } else {
            window.open(`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalBASEURL : getConfigDetails()?.portalBASEURL}/navigating/0/0/0/${facility}/${partner}`, '_self')
        }
    }

    const handleRateDetail = () => {
        if(!rateObj.loader) {
            setRateObj({
                ...rateObj,
                loader: true
            })
            dispatch(fetchRateDetailData(faciltyData?.facility?.id)).then((res) => {
                if(res.data) {
                    setRateObj({
                        ...rateObj,
                        data: res?.data,
                        loader: false
                    })
                    setRateDetailModal({...rateDetailModal, modal: true})
                } else {
                    notify('error', 'Details not found.')
                    setRateObj({
                        ...rateObj,
                        loader: false
                    })
                }
            })
        }
        // fetch('https://staging-api.parkengage.com/rate-details/204').then((res) => res.json()).then((res) => console.log(res, 'response'))
        
    }

    const transientFlow = () => {
        return (
            <>
                {(loginData?.access_token) ?
                    <>
                        <span className='VehilceLables d-flex justify-content-between align-items-start'>Enter Vehicle Details <span onClick={handleAddVehilce}><i className='fa fa-plus small'></i> Add New Vehicle</span></span>
                        <ListGroup as="ol" onClick={() => handleCommonListModal('Vehicle')}>
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                {/* <Image src={carImage} /> */}
                                <span style={{ height: '23px', width: '23px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span>
                                <div className="ms-2 me-auto listVehicleGroupItem">{currentSelVehicle?.license_plate_number}</div>
                                <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                            </ListGroup.Item>
                        </ListGroup>
                    </>
                    :
                    <>
                        <Row>
                            {partner === 'parkingpayments' && <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id='license_plate'
                                        placeholder="License Plate No."
                                        name='license_plate'
                                        maxLength='10'
                                        disabled
                                        // defaultValue={'123'}
                                        {...register('license_plate', {
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 3, message: 'License plate is not valid' },
                                            maxLength: { value: 10, message: 'License plate is not valid' },
                                            onBlur: (e) => handleActiveCheckInCheck(e),
                                            onChange: (e) => handleChange(e)
                                        })}
                                    />
                                </Form.Group>
                                {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                            </Col>}
                            <Col className='col-6'>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Mobile Number {(reservationData.reservationID === null) && <span className='text-danger'>*</span>}</Form.Label>
                                    <Controller
                                        name="phone"
                                        type="text"
                                        id="phone"
                                        control={control}
                                        defaultValue=''
                                        inputmode="numeric"
                                        ref={(e) => { ref(e) }}
                                        rules={{
                                            required: { value: reservationData.reservationID ? false : true, message: 'This field is required' },
                                            minLength: { value: 10, message: 'Please enter a valid number' },
                                            maxLength: { value: 10, message: 'Please enter a valid number' },
                                        }}
                                        render={({ field }) => <MaskedInput
                                            maskGenerator={phoneMaskGenerator}
                                            className="form-control"
                                            {...field}
                                            id="phone"
                                            inputMode="numeric"
                                            maxLength={14}
                                            onChange={(e) => { field.onChange(e); handleChange(getFieldValue('phone', e)) }}
                                            onBlur={() => handleActiveCheckInCheck()}
                                            title="Please enter a valid phone number"
                                            onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="(123)-555-1234"
                                        />
                                        }
                                    />
                                </Form.Group>
                                {errors?.phone && <Form.Text className="text-danger header-s">{errors?.phone?.message}</Form.Text>}
                            </Col>

                            {/* {!ticketDetails?.ticket_number && <Col> */}
                            {/* {partner !== 'parkingpayments' && <Col> */}
                            {<Col className={partner === 'parkingpayments' ? 'col-12' : 'col-6'}>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>State</Form.Label>
                                    <Controller
                                        name='state'
                                        id='state'
                                        control={control}
                                        // rules={{required: { value: true, message: 'This field is required' }}}
                                        render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='no_of_days' defaultValue={field.value} {...field}>
                                            <option>Please Select</option>
                                            {stateList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.state_code}</option>)}
                                        </Form.Select>}
                                    />
                                </Form.Group>
                                {/* {errors?.state && <Form.Text className="text-danger">{errors?.state?.message}</Form.Text>} */}
                            </Col>}
                            {partner == 'demo-parkengage' && <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Zone</Form.Label>
                                    <Controller
                                        name='zone'
                                        id='zone'
                                        control={control}
                                        // rules={{required: { value: true, message: 'This field is required' }}}
                                        render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='no_of_days' defaultValue={field.value} {...field}>
                                            {zoneList?.map((item, itemIndex) => <option key={itemIndex} value={item?.val}>{item?.name}</option>)}
                                        </Form.Select>}
                                    />
                                </Form.Group>
                                {/* {errors?.state && <Form.Text className="text-danger">{errors?.state?.message}</Form.Text>} */}
                            </Col>}
                        </Row>
                        {partner !== 'parkingpayments' && <Row className='row-cols-2  row-cols-sm-3 row-cols-md-3'>
                            <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id='license_plate'
                                        placeholder="License Plate No."
                                        name='license_plate'
                                        maxLength='10'
                                        disabled
                                        {...register('license_plate', {
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 3, message: 'License plate is not valid' },
                                            maxLength: { value: 10, message: 'License plate is not valid' },
                                            onBlur: (e) => handleActiveCheckInCheck(e),
                                            onChange: (e) => handleChange(e)
                                        })}
                                    />
                                </Form.Group>
                                {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Vehicle Make</Form.Label>
                                    <Controller
                                        name='make'
                                        id='make'
                                        control={control}
                                        // rules={{required: { value: true, message: 'This field is required' }}}
                                        render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='make' {...field} onChange={(e) => { field.onChange(e); handleChange(e) }} defaultValue={field?.make}>
                                            <option>Please Select</option>
                                            {vehicleMakeList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
                                        </Form.Select>}
                                    />
                                </Form.Group>
                                {/* {errors?.color && <Form.Text className="text-danger header-s">{errors?.color?.message}</Form.Text>} */}
                            </Col>
                            { othermake ? <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Make</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id='maketext'
                                        placeholder="Vehicle Make"
                                        name='maketext'
                                        maxLength='10'
                                        {...register('maketext', {
                                            // required: { value: true, message: 'This field is required' },
                                            // minLength: { value: 3, message: 'Minimum 3 characters allowed' },
                                            // maxLength: { value: 15, message: 'Maximum 15 characters allowed' },
                                            onBlur: (e) => handleActiveCheckInCheck(e),
                                            onChange: (e) => handleChange(e)
                                        })}
                                    />
                                </Form.Group>
                            </Col> : ''}
                            {!othermake ? <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Vehicle Model</Form.Label>
                                    <Controller
                                        name='model'
                                        id='model'
                                        control={control}
                                        // rules={{required: { value: true, message: 'This field is required' }}}
                                        render={({ field }) => <Form.Select className="form-select selectPalceholdr"  {...field} onChange={(e) => handleChange(e)} name='model' defaultValue={field.model}>
                                            <option>Please Select</option>
                                            {(vehicleModelList?.length > 0) && vehicleModelList?.map((item, itemIndex) => <option key={itemIndex} value={item?.name}>{item?.name}</option>)}
                                        </Form.Select>}
                                    />
                                </Form.Group>
                                
                                {/* {errors?.make && <Form.Text className="text-danger header-s">{errors?.make?.message}</Form.Text>} */}
                            </Col> : ''}
                            {(othermake || othermodel) ? <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Model</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id='modeltext'
                                        placeholder="Vehicle Model"
                                        name='modeltext'
                                        maxLength='10'
                                        {...register('modeltext', {
                                            // required: { value: true, message: 'This field is required' },
                                            // minLength: { value: 3, message: 'Minimum 3 characters allowed' },
                                            // maxLength: { value: 15, message: 'Maximum 15 characters allowed' },
                                            onBlur: (e) => handleActiveCheckInCheck(e),
                                            onChange: (e) => handleChange(e)
                                        })}
                                    />
                                </Form.Group>
                            </Col> : ''}
                            <Col>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>Color</Form.Label>
                                    <Controller
                                        name='color'
                                        id='color'
                                        control={control}
                                        // rules={{required: { value: true, message: 'This field is required' }}}
                                        render={({ field }) => <Form.Select className="form-select selectPalceholdr" onChange={(e) => handleChange(e)} name='color' defaultValue={field.color} {...field}>
                                            <option>Please Select</option>
                                            {(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
                                        </Form.Select>}
                                    />
                                </Form.Group>
                                {/* {errors?.model && <Form.Text className="text-danger header-s">{errors?.model?.message}</Form.Text>} */}
                            </Col>
                        </Row>}
                    </>
                }
                {(!ticketDetails?.ticket_number && reservationData.reservationID === null) && <Row>
                    <Col>
                        {isDisplayRateBand ?
                            <>
                                <div className='mt-3 mb-3'>
                                    {rateBands?.rateBands?.length > 0 && <>
                                        <Form.Label className='text-primary mb-0 pb-0 styleLables'>Rate Band <span className='text-danger'>*</span></Form.Label>
                                        <ReactMobiltySpinner
                                            handleTimeLength={(e) => handleTimeLength(e)}
                                            isRateBand
                                            currDays={timeDuration?.days}
                                            rateBands={rateBands}
                                            isRateBandSelected={isRateBandSelected}
                                            setIsRateBandSelected={setIsRateBandSelected}
                                            setselctedDateTime={setselctedDateTime}
                                            selctedDateTime={selctedDateTime}
                                            rateBandData={rateBandData}
                                        />

                                        {/* <ListGroup as="ol" onClick={() => handleRateBandModal('rate_band')}>
                                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                                {!currentRateBand?.rate_band_description && <Form.Text className="header-m">Select Rate Band</Form.Text>}
                                                <div className="ms-2 me-auto listVehicleGroupItem">{currentRateBand?.rate_band_description}</div>
                                                <i className='fa fa-angle-down mt-1' style={{ fontSize: '15px' }}></i>
                                            </ListGroup.Item>
                                        </ListGroup> */}
                                        <div className='text-end d-flex align-items-center justify-content-end'>
                                            {rateObj.loader && <><div><Loader color='grey' hideMargin size='16' /></div><span>&nbsp;</span></>}
                                            <span className={`p-0 btn btn-link btn-sm mt-0${rateObj.loader?' disabled':''}`} onClick={handleRateDetail}>Rate Detail</span>
                                        </div>
                                        <RateDetailsModal rateDetailModal={rateDetailModal} setRateDetailModal={setRateDetailModal} rateObj={rateObj} />
                                    </>
                                    }
                                    <div className='p-0 m-0 d-flex justify-content-center align-items-center row'>
                                        <div className={`${selctedDateTime.bandActive ? 'border-primary' : 'border-grey'} border border-2 rounded m-2 pb-2 pt-2`} onClick={openDateCalendar}>
                                            <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                <div className='lh-sm'>{(selctedDateTime.active) ? selctedDateTime.daysHrs : 'Custom Date & Time'}<div className='sub-label small text-muted'><small>{(selctedDateTime.active) ? 'Until ' + getDateFormatToshow(selctedDateTime.dateUntill) : 'Select Date & Time'}</small></div></div>
                                                <span>{(selctedDateTime.active) ? '$' + Number(selctedDateTime.price).toFixed(2) : '--'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>


                            : <div className='mt-3'><ReactMobiltySpinner
                                handleTimeLength={(e) => handleTimeLength(e)}
                                currDays={timeDuration?.days}
                                currHour={timeDuration?.hours}
                                currMin={timeDuration?.minutes}
                                isMultiParking={faciltyData?.facility?.is_multiday_parking != 0}
                                setIsRateBandSelected={setIsRateBandSelected}
                                setselctedDateTime={setselctedDateTime}
                                selctedDateTime={selctedDateTime}
                                rateBandData={rateBandData}
                            /></div>}
                    </Col>
                </Row>}
            </>
        )
    }
    

    if(id) {
        useEffect(() => {
            localStorage.removeItem('lpr')
            localStorage.removeItem('lprExit')
            // let payload = {
            //     encrypt: facility
            // }
            // console.log(payload, 'payload new')
            // dispatch(getFacilityRateDetails(payload)).then((res) => {
            //     console.log(res, 'response')
            // })
            dispatch(getWarningDetails(id.toLocaleUpperCase())).then((res) => {
                if(res.data) {
                    // console.log(res.data, 'response new')
                    const toDate = new Date(getConvertedDate(moment(new Date()).tz(res.data?.facility?.timezone ? res.data?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')))
                    let showLicense = false
                    if(vehicleData.length > 0) {
                        vehicleData.map((resp) => {
                            if(resp.license_plate_number == res.data.license_plate) {
                                showLicense = true
                                setCurrentVehicle(resp)
                            }
                        })
                    }
                    // license_plate
                    if(res.data?.lprDetails) {
                        localStorage.setItem('lpr', JSON.stringify(res.data?.lprDetails))
                    }
                    if(res.data?.lprExitDetails) {
                        localStorage.setItem('lprExit', JSON.stringify(res.data?.lprExitDetails))
                    }
                    setValue('license_plate', res.data.license_plate ? res.data.license_plate : '')
                    SetwarnCitData({ ...warnCitData, warning: res.data, citation: null, showLicense: showLicense, timeZone: res.data?.facility?.timezone })
                    SetstEndCalendar({
                        ...stEndCalendar,
                        start_date: res.data?.lprDetails ? res.data.lprDetails?.entry_time : (!res.data.lprDetails && res.data.lprExitDetails) ? null : res.data?.first_scan_date ? res.data.first_scan_date : toDate, 
                        end_date: res.data?.lprExitDetails ? res.data.lprExitDetails.entry_time : null,
                        defaultEndDate: res.data?.lprExitDetails ? true : false
                    })
                    if(res.data?.lprDetails || res.data.lprExitDetails) {
                        setIsRateBandSelected(false)
                    }
                } else {
                    if(res?.errors?.message) {
                        // notify('error', res?.errors?.message)
                        setErrorMessageLocal(res?.errors?.message)
                        // this error shows
                    } else {
                        notify('error', errorMessage?.somethingWentWrong)
                    }                 
                    setNoPage(true)
                }
            })
        },[])

        useEffect(() => {
            // facility, partner, route, id
            let payload = {
                'encrypt': facility,
                'promocode': '',
                'is_guest': '1',
                'phone': '',
                'license_plate': '',
                'length': '1.00',
                'is_warning': 1,
            }
            // console.log(seletedRateBand?.[0]?.id, 'rate bands')
            if( stEndCalendar.start_date && stEndCalendar.end_date && !isRateBandSelected ) {
            // if( stEndCalendar.start_date && stEndCalendar.end_date ) {
                const formData = getValues()
                let hoursDiff = diff_hours(stEndCalendar.end_date, stEndCalendar.start_date)
                payload.length = hoursDiff
                payload.phone = formData?.phone ? formData?.phone : ''
                payload.license_plate = formData?.license_plate ? formData?.license_plate : ''
                payload.entry_time = stEndCalendar.start_date
                payload.exit_time = stEndCalendar.end_date
                // console.log(payload, 'payload')
                dispatch(getFacilityRateDetails(payload)).then((res) => {
                    if (res?.data) {
                        // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.parking_amount ? res?.data?.parking_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_rate ? res?.data?.tax_rate : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee ? res?.data?.processing_fee : '0.00'}` }]
                        // if (fromDatePicker) {
                        //     setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                        // }
                        // console.log(selctedDateTime, 'selctedDateTime', res.data)
                        const data = res?.data
                        data.default_length = data?.default_length?.toString()
                        localStorage.setItem('faclityData', JSON.stringify(data))
        
        
                        const dcap = {
                            DATACAP_OTU_URL: data?.DATACAP_OTU_URL,
                            DATACAP_SCRIPT_URL: data?.DATACAP_SCRIPT_URL,
                            DATACAP_TOKEN: data?.DATACAP_TOKEN,
                        }
                        localStorage.setItem('dcap', JSON.stringify(dcap))
                        setStateList(res?.data?.states)
        
                        // rate band start 
                        // if (fetchByRate) {
                        //     const rateDataFectched = { ...faciltyData, ...res?.data }
                        //     setFaciltyData(rateDataFectched)
                        // } else {
                        //     setFaciltyData(res?.data)
                        // }
                        setFaciltyData(res?.data)
        
                        // rate band end 
                        const geoState = res?.data?.facility?.geolocations?.state?.trim()
                        const filteredState = res?.data?.states?.filter((item) => (item?.state_code === geoState || item?.name === geoState) ? item : 0)
        
                        setValue('state', getValues('state') ? getValues('state') : filteredState[0]?.id ? filteredState[0]?.id : getValues('state'))
        
                        if (data?.facility?.is_price_band == '1') {
                            // SET RATE BAND TRUE
                            setIsDisplayRateBand(true)
                            // FETCH RATE BANDS API DETAILS
                            const payload = {
                                facility_id: res?.data?.facility?.id,
                                user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                            }
                            dispatch(fetchRateBands(payload)).then((res) => {
                                if (res?.data) {
                                    // SET RATE BANDS DATA
                                    // console.log(res.data, 'res.data')
                                    if(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) {
                                        // console.log('I am here... 5')
                                        SetwarnCitData({ ...warnCitData, recall: warnCitData.recall + 1 })
                                        // lprFuncTocalc()
                                    } else {
                                        setRateBandData(res?.data?.price_band)
                                        const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                                        const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                                        // const defaultRateBand = [
                                        //     'Select Rate Band'
                                        // ]
                                        const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                        // console.log(res?.data?.price_band, rateBands, 'I am here... 3')
                                        setRateBands(rateBands)
                                    }
                                } else {
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                }
                            }).catch((err) => {
                                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            })
                        }
        
                        if (loggedInUserData()?.access_token) {
                            const payload = {
                                facility_id: res?.data?.facility?.id,
                                user_id: loggedInUserData()?.user?.id
                            }
                            setIsCheckingActiveSession(true)
                            dispatch(checkActiveSession(payload)).then((res) => {
                                if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
                                    let paymentData = res?.data?.checkin_details
                                    if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
                                        localStorage.setItem('isCouponApplied', true)
                                    }
        
                                    delete res?.data?.checkin_details
                                    const facility = res?.data
                                    const finalPaymentData = { ...paymentData, facility: facility }
                                    localStorage.removeItem('paymentRecipt')
                                    localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                    navigate(`/${partner}${URL?.CONFIRMATION}`)
                                    setIsCheckingActiveSession(false)
                                } else {
                                    setIsTokenApiStart(false)
                                    setIsCheckingActiveSession(false)
                                }
                            }).catch(() => {
                                setIsTokenApiStart(false)
                                setIsCheckingActiveSession(false)
                                // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            })
                        } else {
                            setIsCheckingActiveSession(false)
                            setIsTokenApiStart(false)
                        }
                    } else {
                        setIsTokenApiStart(false)
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        if (res?.errors?.message == 'Garage is currently closed.') {
                            setAvalablityAlertIsOpen(true)
                            setAvalablityMessage(res?.errors?.message)
                        } else if(res?.errors?.message == 'The Facility is not operational at this moment.') {
                            setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            setIsCheckingActiveSession(false)
                        } else {
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }
                })
            }
        },[stEndCalendar])
        
        useEffect(() => {
            if(rateBandData.length > 0 && (warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) && warnCitData.recall < 2) {
                lprFuncTocalc()
            }
        }, [rateBandData, rateBands, warnCitData])
    }

    const lprFuncTocalc = () => {
        SetwarnCitData({ ...warnCitData, recall: warnCitData.recall + 1 })
        // console.log(warnCitData, 'hoursDiff 4')
        let lprDate =  warnCitData?.warning?.lprDetails?.entry_time ? new Date(getConvertedDate(moment(new Date(warnCitData?.warning?.lprDetails?.entry_time)).format('YYYY-MM-DD HH:mm:ss'))) : warnCitData?.warning?.lprExitDetails?.entry_time ? new Date(getConvertedDate(moment(new Date(warnCitData?.warning?.lprExitDetails?.entry_time)).format('YYYY-MM-DD HH:mm:ss'))) : new Date(getConvertedDate(moment(new Date()).tz(warnCitData?.timeZone ? warnCitData.timeZone : faciltyData?.facility?.timezone ? faciltyData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        let curTime = warnCitData?.warning?.lprExitDetails?.entry_time ? new Date(getConvertedDate(moment(warnCitData?.warning?.lprExitDetails?.entry_time).format('YYYY-MM-DD HH:mm:ss'))) : new Date(getConvertedDate(moment(new Date()).tz(warnCitData?.timeZone ? warnCitData.timeZone : faciltyData?.facility?.timezone ? faciltyData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        let hoursDiff = moment(curTime).diff(lprDate, 'minutes')
        // console.log(curTime, lprDate, 'hoursDiff 1')
        let data = rateBandData.filter((item) => {
            let hourToMin = Number(item.max_stay) * 60
            return hourToMin > hoursDiff
        })
        // console.log(data, 'hoursDiff')
        setRateBandData(data)
        const rateBandsForSelection = data?.map((item) => item?.rate_band_description)
        const priceForRateBrands = data?.map((item) => item?.price)
        const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
        setRateBands(rateBands)
        // console.log(rateBands, data, hoursDiff, 'I am here... 4')
    }

    const warningCitFlow = () => {
        const openStartCalendar = (start = false) => {
            if(start) {
                if(warnCitData?.warning?.lprDetails?.entry_time) {
                    return false
                } else {
                    SetstEndCalendar({ ...stEndCalendar, start: true, end: false })
                }
            } else {
                if(warnCitData?.warning?.lprExitDetails?.entry_time) {
                    return false
                } else {
                    SetstEndCalendar({ ...stEndCalendar, start: false, end: true })
                }
            }
        }
        // console.log(loginData, 'loginData?.access_token')
        return (
            <>
                {(loginData?.access_token) ?
                    <>
                        <Row className='g-1'>
                            {warnCitData.showLicense ? <Col className='col-12 col-md-6 mb-2'>
                                <span className='VehilceLables d-flex justify-content-between align-items-start'>Enter Vehicle Details <span onClick={handleAddVehilce}><i className='fa fa-plus small'></i> Add New Vehicle</span></span>
                                <ListGroup as="ol" onClick={() => handleCommonListModal('Vehicle')}>
                                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                        {/* <Image src={carImage} /> */}
                                        <span style={{ height: '23px', width: '23px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span>
                                        <div className="ms-2 me-auto listVehicleGroupItem">{currentSelVehicle?.license_plate_number}</div>
                                        <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col> : 
                            <Col className='col-12 col-md-6 mb-2'>
                                <Form.Group>
                                    <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id='license_plate'
                                        placeholder="License Plate No."
                                        defaultValue={warnCitData?.warning?.license_plate ? warnCitData.warning.license_plate : ''}
                                        name='license_plate'
                                        maxLength='10'
                                        disabled
                                        {...register('license_plate', {
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 3, message: 'License plate is not valid' },
                                            maxLength: { value: 10, message: 'License plate is not valid' },
                                            onBlur: (e) => handleActiveCheckInCheck(e),
                                            onChange: (e) => handleChange(e)
                                        })}
                                    />
                                </Form.Group>
                                {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                            </Col>}
                            {(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) ? <>
                                <Col className='col-6 mb-2'>
                                    <label className="text-primary  styleLables form-label"> Start Date & Time</label>
                                    <div onClick={() => openStartCalendar(true)} className="form-control d-flex px-1 justify-content-between align-items-center ">
                                        <div className='small'>{(stEndCalendar?.start_date) ? getDateFormatToshow(stEndCalendar?.start_date) : 'Select Date & Time'}</div>
                                        <i className='fa fa-calendar'></i>
                                    </div>
                                </Col>
                                <Col className='col-6 mb-2'>
                                    <label className="text-primary  styleLables form-label"> End Date & Time</label>
                                    <div onClick={() => openStartCalendar(false)} className="form-control d-flex px-1 justify-content-between align-items-center ">
                                        <div className='small'>{(stEndCalendar?.end_date) ? getDateFormatToshow(stEndCalendar?.end_date) : 'Select Date & Time'}</div>
                                        <i className='fa fa-calendar'></i>
                                    </div>
                                </Col>
                            </> : ''}
                        </Row>
                        <WarningModal setModaltog={setModaltog} modaltog={modaltog} />
                    </> : <>
                    <Row className='g-1 g-sm-3 '>
                        <Col className='col-6 mb-2'>
                            <Form.Group>
                                <Form.Label className='text-primary  styleLables'>Mobile Number {(reservationData.reservationID === null) && <span className='text-danger'>*</span>}</Form.Label>
                                <Controller
                                    name="phone"
                                    type="text"
                                    id="phone"
                                    control={control}
                                    defaultValue=''
                                    inputmode="numeric"
                                    ref={(e) => { ref(e) }}
                                    rules={{
                                        required: { value: reservationData.reservationID ? false : true, message: 'This field is required' },
                                        minLength: { value: 10, message: 'Please enter a valid number' },
                                        maxLength: { value: 10, message: 'Please enter a valid number' },
                                    }}
                                    render={({ field }) => <MaskedInput
                                        maskGenerator={phoneMaskGenerator}
                                        className="form-control"
                                        {...field}
                                        id="phone"
                                        inputMode="numeric"
                                        maxLength={14}
                                        onChange={(e) => { field.onChange(e); handleChange(getFieldValue('phone', e)) }}
                                        onBlur={() => handleActiveCheckInCheck()}
                                        title="Please enter a valid phone number"
                                        onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                        onInput={e => e.target.setCustomValidity('')}
                                        placeholder="(123)-555-1234"
                                    />
                                    }
                                />
                            </Form.Group>
                            {errors?.phone && <Form.Text className="text-danger header-s">{errors?.phone?.message}</Form.Text>}
                        </Col>
                        {partner === 'parkingpayments' && <Col className='col-6 mb-2'>
                        <Form.Group>
                            <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                    type="text"
                                    id='license_plate'
                                    placeholder="License Plate No."
                                    name='license_plate'
                                    maxLength='10'
                                    disabled
                                    defaultValue={warnCitData?.warning?.license_plate ? warnCitData.warning.license_plate : ''}
                                    {...register('license_plate', {
                                        required: { value: true, message: 'This field is required' },
                                        minLength: { value: 3, message: 'License plate is not valid' },
                                        maxLength: { value: 10, message: 'License plate is not valid' },
                                        onBlur: (e) => handleActiveCheckInCheck(e),
                                        onChange: (e) => handleChange(e)
                                    })}
                                />
                            </Form.Group>
                            {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                        </Col>}
                        {partner !== 'parkingpayments' && <Col className='col-6 mb-2'>
                            <Form.Group>
                                <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    id='license_plate'
                                    placeholder="License Plate No."
                                    defaultValue={warnCitData?.warning?.license_plate ? warnCitData.warning.license_plate : ''}
                                    name='license_plate'
                                    maxLength='10'
                                    disabled
                                    {...register('license_plate', {
                                        required: { value: true, message: 'This field is required' },
                                        minLength: { value: 3, message: 'License plate is not valid' },
                                        maxLength: { value: 10, message: 'License plate is not valid' },
                                        onBlur: (e) => handleActiveCheckInCheck(e),
                                        onChange: (e) => handleChange(e)
                                    })}
                                />
                            </Form.Group>
                            {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                        </Col>}
                        {(warnCitData?.warning?.lprDetails || warnCitData?.warning?.lprExitDetails) ? <>
                            <Col className='col-6 mb-2'>
                                <label className="text-primary  styleLables form-label"> Start Date & Time</label>
                                <div onClick={() => openStartCalendar(true)} className="form-control d-flex px-1 justify-content-between align-items-center ">
                                    <div className='small'>{(stEndCalendar?.start_date) ? getDateFormatToshow(stEndCalendar?.start_date) : 'Select Date & Time'}</div>
                                    <i className='fa fa-calendar'></i>
                                </div>
                            
                            </Col>
                            <Col className='col-6 mb-2'> 
                                <label className="text-primary  styleLables form-label"> End Date & Time</label>
                                <div onClick={() => openStartCalendar(false)} className="form-control d-flex px-1 justify-content-between align-items-center ">
                                    <div className='small'>{(stEndCalendar?.end_date) ? getDateFormatToshow(stEndCalendar?.end_date) : 'Select Date & Time'}</div>
                                    <i className='fa fa-calendar'></i>
                                </div>
                            </Col>
                        </>: ''}
                    </Row>
                    <WarningModal setModaltog={setModaltog} modaltog={modaltog} />
                </>}
                {(!ticketDetails?.ticket_number && reservationData.reservationID === null) && <Row>
                    <Col>
                        {isDisplayRateBand ?
                            <>
                                <div className='mt-3 mb-3'>
                                    {rateBands?.rateBands?.length > 0 && <>
                                        <Form.Label className='text-primary mb-0 pb-0 styleLables'>Rate Band <span className='text-danger'>*</span></Form.Label>
                                        <ReactMobiltySpinner
                                            handleTimeLength={(e) => handleTimeLength(e)}
                                            isRateBand
                                            currDays={timeDuration?.days}
                                            rateBands={rateBands}
                                            isRateBandSelected={isRateBandSelected}
                                            setIsRateBandSelected={setIsRateBandSelected}
                                            setselctedDateTime={setselctedDateTime}
                                            selctedDateTime={selctedDateTime}
                                            rateBandData={rateBandData}
                                            warning
                                            SetstEndCalendar={SetstEndCalendar}
                                            stEndCalendar={stEndCalendar}
                                        />

                                        {/* <ListGroup as="ol" onClick={() => handleRateBandModal('rate_band')}>
                                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                                {!currentRateBand?.rate_band_description && <Form.Text className="header-m">Select Rate Band</Form.Text>}
                                                <div className="ms-2 me-auto listVehicleGroupItem">{currentRateBand?.rate_band_description}</div>
                                                <i className='fa fa-angle-down mt-1' style={{ fontSize: '15px' }}></i>
                                            </ListGroup.Item>
                                        </ListGroup> */}
                                        <div className='text-end d-flex align-items-center justify-content-end'>
                                            {rateObj.loader && <><div><Loader color='grey' hideMargin size='16' /></div><span>&nbsp;</span></>}
                                            <span className={`p-0 btn btn-link btn-sm mt-0${rateObj.loader?' disabled':''}`} onClick={handleRateDetail}>Rate Detail</span>
                                        </div>
                                        <RateDetailsModal rateDetailModal={rateDetailModal} setRateDetailModal={setRateDetailModal} rateObj={rateObj} />
                                    </>
                                    }
                                </div>
                            </>


                            : <div className='mt-3'><ReactMobiltySpinner
                                handleTimeLength={(e) => handleTimeLength(e)}
                                currDays={timeDuration?.days}
                                currHour={timeDuration?.hours}
                                currMin={timeDuration?.minutes}
                                isMultiParking={faciltyData?.facility?.is_multiday_parking != 0}
                                setIsRateBandSelected={setIsRateBandSelected}
                                setselctedDateTime={setselctedDateTime}
                                selctedDateTime={selctedDateTime}
                                rateBandData={rateBandData}
                            /></div>}
                    </Col>
                </Row>}
            </>
        )
    }

    return (
        isFetchingPartner ? null : (id && noPage) ? <div className={'Pave d-flex justify-content-center align-items-center cust-error-wrap'}><NoData className='w-100' message={(errorMessageLocal) ? errorMessageLocal : errorMessage?.invalidFacility} /></div> : <div className={'Pave main'}>
            {/* {!id && <MiniHeader title={'PARKING DETAILS'} loginData={loginData} partnerdetails={partnerdetails} />} */}
            {(isValidPartner) ?
                ((loader && totalHoursLength == '0.00') || (isCheckingActiveSession && totalHoursLength == '0.00')) ?
                    <div className='d-flex align-items-center justify-content-center'><Loader /></div> :
                    (faciltyData?.facility?.full_name && (faciltyData?.facility?.owner_id == partnerdetails?.id)) ?
                        <div>
                            
                                {(!id && (isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Permit Purchase') || isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Reservation'))) ? <div className="p-3 text-center">
                                    <div className='d-flex gap-3 mb-2'>
                                        {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Permit Purchase') ? <button
                                            className="btn bg-primary text-white w-100"
                                            onClick={() => handlePermitPurchase()}
                                        >
                                            Purchase Permit
                                        </button> : null }
                                        {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Reservation') ? <button
                                            className="btn bg-primary text-white w-100"
                                            onClick={() => setResetModalOpen(true)}
                                        >
                                            Reservations
                                        </button> : null }
                                    </div>
                                    <h3>OR</h3>
                                    <p className="text-primary mb-2">Check-in Using Below</p>
                                    <i className="fa fa-chevron-circle-down text-muted fa-2x" aria-hidden="true"></i>
                                </div> : null }
                                <Modal isOpen={isResetModalOpen} toggle={toggle}>
                                    <ModalHeader toggle={toggle}>Enter Reservation ID</ModalHeader>
                                    <ModalBody>
                                        <ReservationWithID toggle={toggle} setFaciltyData={setFaciltyData} faciltyData={faciltyData} setTotalHoursLength={setTotalHoursLength} setReservationData={setReservationData} reservationData={reservationData} notify={notify} />
                                    </ModalBody>
                                    {/* <ModalFooter>
                                        <Button className='modalButton' color="secondary" onClick={toggle}> Cancel </Button>
                                    </ModalFooter> */}
                                </Modal>
                            
                            <UpperHeader faciltyData={faciltyData} totalHoursLength={totalHoursLength?.toString()} key='main' reservationData={reservationData} modaltog={modaltog} setModaltog={setModaltog} warnCitID={id} />
                            <Container>
                                <div className='mt-4'>
                                    { id ? warningCitFlow() : transientFlow() }
                                </div>
                            </Container>

                            {/* PromoCode ---- */}
                            {/* {partner !== 'intrapark' && */}
                            {(isPromoValidateButton(faciltyData, ['1', '3']) && reservationData.reservationID === null) && <PromoCode
                                facility={facility}
                                length={totalHoursLength}
                                setStateList={setStateList}
                                setFaciltyData={setFaciltyData}
                                setValue={setValue}
                                getValues={getValues}
                                notify={notify}
                                setErrorMessageLocal={setErrorMessageLocal}
                                screen='transientForm'
                            />
                            }

                            {ticketDetails?.ticket_number ? null :
                                reservationData.reservationID === null ? <div className="container pt-3 pb-5 overflow-hidden no-ticket-view">
                                    <div className={(!priceGreaterOrNot(faciltyData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
                                        {/* {(priceGreaterOrNot(faciltyData) && !loader) && <p className='text-primary fw-semibold py-3 px-2 mx-3 mb-2 bg-opacity-10 custom-dashed-border' >Price Breakdown</p>} */}
                                        <PaymentBreakUpDetails
                                            loader={loader}
                                            isSubmittingForm={isSubmittingForm}
                                            // faciltyData={faciltyData}
                                            paymentData={faciltyData}
                                            className='py-2 d-flex'
                                            sectionKey={(faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                                            isDisplayDetails={true}
                                            setIsDisplayDetails={setIsDisplayDetails}
                                        />
                                        <div className="card-footer">
                                            {!ticketDetails?.ticket_number && <AmountPaid
                                                className='py-2 pb-3 px-2'
                                                paymentData={faciltyData}
                                                paybleText="Amount Due"
                                                hideTaxIncluded={(faciltyData?.payable_amount > 0 && (((faciltyData?.tax_fee && faciltyData?.tax_fee != '0.00') || (faciltyData?.tax_rate && faciltyData?.tax_rate != '0.00')))) ? false : true}
                                                setIsDisplayDetails={setIsDisplayDetails}
                                                isInfo
                                                sectionKey={'payableAmount'}
                                                isTokenApiStarts={isTokenApiStarts}
                                                cardInside
                                            />}
                                        </div>
                                    </div>
                                </div> : ''}
                            {ticketDetails?.ticket_number && <Container>
                                <Col>
                                    <Form.Group>
                                        <p className='textColorText small mt-3'>
                                            {errorMessage?.activeCheckinMessage}
                                        </p>
                                    </Form.Group>
                                </Col>
                            </Container>}
                            <div>
                                {ticketDetails?.ticket_number ? <Link to={`/${partner}${URL?.TICKET_DETAILS}`} className="btn w-100 my-4 fw-bold text-white bg-primary">Check Details</Link> :
                                    /* new payment gateway */
                                    <>
                                        {reservationData.reservationID === null ? <Card className='m-2 paymentCardRadious p-2'>
                                            {(loginData?.access_token) ?
                                                <>

                                                    <span className='VehilceLables d-flex justify-content-between align-items-start'>Enter Payment Details <span onClick={handlePaymentModal}><i className='fa fa-plus small'></i> Add New Card</span></span>
                                                    <ListGroup as="ol" onClick={() => handleCommonListModal('Card')} className='mt-2'>
                                                        <ListGroup.Item as="li" className="ps-1 d-flex justify-content-between align-items-start">
                                                            {/* <Image className='img-10' src={card_top_image} /> */}
                                                            <span style={{ height: '25px', width: '25px' }}>{getSvgIcon('Credit_card', 'var(--bs-primary)')}</span>
                                                            <div className="ms-2 me-auto text-secondary">Payment Method</div>
                                                            {(currentSelCard?.card_last_four) ? <div className='ms-2' style={{ marginTop: '-1px', marginRight: '3px' }}><Image src={getCardIcon(currentSelCard?.card_type)} style={{ height: '1.1rem', 'marginTop': '-0.2rem' }} /> <span className='text-primary fw-semibold me-1' >{currentSelCard?.card_last_four}</span></div> : <i className="fa fa-credit-card mr-2" style={{ marginRight: '0.5rem', marginTop: '4px' }} ></i>}
                                                            <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                                        </ListGroup.Item>
                                                    </ListGroup>


                                                </>
                                                :
                                                <PaymentGateDc parkingBtnTxt={(id) ? true : false} faciltyData={faciltyData} loader={loader} isSubmittingForm={isSubmittingForm} errors={errors} register={register} control={control} onSubmit={handleSubmit(onSubmit)} isTokenApiStarts={isTokenApiStarts} isInScreen setFocus={setFocus} />
                                            }
                                        </Card> : ''}
                                        {(loginData?.access_token || reservationData.reservationID) && <div className="ms-2 me-2 mt-4">
                                            <button type="submit" name="submit" className="btn w-100 text-white bg-primary" style={{opacity: (isSubmittingForm ? true : loader) ? '0.7' : '1'}} onClick={handleSubmit(onSubmit)} disabled={(isSubmittingForm) ? true : loader} >
                                                <div className='d-flex justify-content-center align-items-center'>
                                                    <h5 className='mb-0 fw-bold'>Start Parking</h5> <span className='ms-2'>
                                                        {((isSubmittingForm) ? true : loader) ? <Circles
                                                            height="20"
                                                            width="20"
                                                            style={{ display: 'inline-block' }}
                                                            color="#ffffff"
                                                            ariaLabel="circles-loading"
                                                            visible={true}
                                                        /> : null}
                                                    </span>
                                                </div>
                                            </button>
                                        </div>}
                                    </>
                                }
                            </div>
                        </div>
                        :
                        <NoData message={(errorMessageLocal) ? errorMessageLocal : errorMessage?.invalidFacility} />
                : <NoData message={errorMessage?.invalidPartner} />}
            <PaymentBreakUpDetails
                loader={loader}
                // faciltyData={faciltyData}
                isSubmittingForm={isSubmittingForm}
                paymentData={faciltyData}
                className='py-2'
                sectionKey={(faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                isDisplayDetails={isDisplayDetails}
                setIsDisplayDetails={setIsDisplayDetails}
            />
            <VehicleHod isVehicleModalOpen={isVehicleModalOpen} setIsVehicleModalOpen={setIsVehicleModalOpen} notify={notify} isInTransient />
            <PaymentModal isPaymentModalOpen={isPaymentModalOpen} setIsPaymentModalOpen={setIsPaymentModalOpen} notify={notify} isInScreen />
            <CommonListModal setCommonModal={setCommonModal} isCommonModalOpen={isCommonModalOpen} listData={(selOptionFlag === 'Vehicle') ? vehicleDataList : cards} isThisVehicleModal={(selOptionFlag === 'Vehicle') ? true : false} register={register} handleCurrentSelection={handleCurrentSelection} />
            <ScrollCalendar isScrollCalendarModal={isScrollCalendarModal} setIsScrollCalendarModal={setIsScrollCalendarModal} setEntryDateTime={setEntryDateTime} handleEntryTime={handleEntryTime} entryDateTime={entryDateTime} isDateShow={false} setSeletedRateBand={setSeletedRateBand} />
            <StartEndDateTime setIsRateBandSelected={setIsRateBandSelected} SetstEndCalendar={SetstEndCalendar} stEndCalendar={stEndCalendar} startCal={stEndCalendar.start} warnCitData={warnCitData} />
            {/* rate band modal*/}
            <RateBandDropDownList setIsRateBandModal={setIsRateBandModalOpen} isRateBandModal={isRateBandModalOpen} listData={rateBandData} register={register} handleCurrentSelection={handleCurrentSelection} />
            {displayBanner ? <DownloadApp /> : null}
            {/* IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN */}
            {/* <ActiveSession activeSessionData={activeSessionData}/> */}
            <Footer />
            <ConfirmationTerms
                isConfimationModalOpen={isConfimationModalOpen}
                setIsConfimationModalOpen={setIsConfimationModalOpen}
                setIsSubmittingForm={setIsSubmittingForm}
                isSubmittingForm={isSubmittingForm}
                Message='You already have one active parking session. Please confirm if you want to end this first before proceeding further.'
                cancelButton={true}
                SubmitButton={false}
                isHandleSubmit
                cancelButtonLabel='No'
                SubmitButtonLable='Yes'
                SubmitButtonColor='text-primary'
                handleSubmit={loginData?.access_token ? handleLoggedInUserCheckIn : handleGuestUserCheckIn}
                warning='1'
                data={formData}
            />

            <ParkingSchModal
                isModalOpen={warningMessageSchdule}
                setIsModalOpen={setWarningPark}
                setIsSubmittingForm={setIsSubmittingForm}
                Message={warningMessage}
                data={hoursOfOper}
                midnighNote={midnighNote}
                isHandleSubmit
                cancelButton={true}
                SubmitButton={false}
                cancelButtonLabel='No'
                SubmitButtonLable='Yes'
                SubmitButtonColor='text-primary'
                handleSubmit={handleSubmitAction}
            />

            <ConfirmationTerms
                setIsSubmittingForm={setIsSubmittingForm}
                isConfimationModalOpen={avalablityAlert}
                setIsConfimationModalOpen={setAvalablityAlertIsOpen}
                Message={availabilityMessage}
                cancelButton={true}
                cancelButtonLabel='OK'
                cancleButtonColor='text-primary'
            />
        </div>
    )


}

TransientForm.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    cards: PropTypes.array,
    vehicleDataList: PropTypes.array,
    isFetchingPartner: PropTypes.bool,
    partnerDetails: PropTypes.object,
}

TransientForm.defaulProps = {
    dispatch: noop,
    loader: true,
    isFetching: true,
    notify: noop,
    cards: EMPTY_ARRAY,
    vehicleDataList: EMPTY_ARRAY,
    isFetchingPartner: true,
    partnerDetails: EMPTY_OBJECT,

}

function mapStateToProps({ transientReducer, PaymentReducer, VehilceReducer, userDetailsReducer }) {
    const { data } = VehilceReducer

    return {
        loader: transientReducer?.loader,
        isFetching: transientReducer?.loader,
        cards: PaymentReducer?.data?.data?.payments,
        vehicleDataList: data?.data,
        isFetchingPartner: userDetailsReducer?.isFetching,
    }
}

export default connect(mapStateToProps)(TransientForm)